// The header bell's badge (T24) — the real unread count from
// GET /notifications/unread-count, not a fixed number.
//
// The key sits under `['notifications']`, which useRealtimeNotifications
// invalidates on every `notification:new` and the Notification Centre
// invalidates after marking read, so the badge follows both. The interval
// covers a dropped socket.

import { useQuery } from '@tanstack/react-query';
import { notificationService } from '@/services/notification.service';
import { useAuthStore } from '@/stores/use-auth-store';
import { UNREAD_COUNT_QUERY_KEY } from '@/pages/notifications/notification-links';

export function useUnreadNotificationCount(): number {
  // Platform users have no tenant inbox.
  const tenantId = useAuthStore((s) => s.profile?.tenant?.id);
  const { data } = useQuery({
    queryKey: UNREAD_COUNT_QUERY_KEY,
    queryFn: () => notificationService.getUnreadCount(),
    enabled: Boolean(tenantId),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
  return tenantId ? (data ?? 0) : 0;
}
